export const PASTEL_COLORS = [
  { name: 'Rose Quartz', hex: '#FFE4E1' },
  { name: 'Serenity Blue', hex: '#B4D4E7' },
  { name: 'Mint Green', hex: '#C5E8D5' },
  { name: 'Lavender', hex: '#E6E6FA' },
  { name: 'Peach', hex: '#FFDAB9' },
  { name: 'Baby Blue', hex: '#D4E9F7' },
  { name: 'Pale Yellow', hex: '#FFFACD' },
  { name: 'Blush Pink', hex: '#FFE4EC' },
  { name: 'Soft Coral', hex: '#FFD7CC' },
  { name: 'Light Lilac', hex: '#DCD0FF' },
  { name: 'Pale Sage', hex: '#D4E5D7' },
  { name: 'Cream', hex: '#FFF8DC' },
] as const;

export type PastelColor = (typeof PASTEL_COLORS)[number];

/** Get a random pastel color from the palette */
export function getRandomPastelColor(): PastelColor {
  const index = Math.floor(Math.random() * PASTEL_COLORS.length);
  return PASTEL_COLORS[index];
}

// Professional dark/muted colors for high-quality ad backgrounds
export const PROFESSIONAL_COLORS = [
  { name: 'Charcoal', hex: '#2D3436' },
  { name: 'Slate Gray', hex: '#636E72' },
  { name: 'Deep Navy', hex: '#1B2838' },
  { name: 'Midnight Blue', hex: '#2C3E50' },
  { name: 'Dark Teal', hex: '#1A535C' },
  { name: 'Forest Green', hex: '#2D5016' },
  { name: 'Deep Red', hex: '#8B1A1A' },
  { name: 'Burgundy', hex: '#722F37' },
  { name: 'Dark Purple', hex: '#4A1942' },
  { name: 'Steel Blue', hex: '#4682B4' },
  { name: 'Espresso', hex: '#3C2415' },
  { name: 'Gunmetal', hex: '#2A3439' },
] as const;

export type ProfessionalColor = (typeof PROFESSIONAL_COLORS)[number];

/** Get a random professional color from the palette */
export function getRandomProfessionalColor(): ProfessionalColor {
  const index = Math.floor(Math.random() * PROFESSIONAL_COLORS.length);
  return PROFESSIONAL_COLORS[index];
}

/** Check if a URI is a pastel color URI (pastel:#HEXCOLOR) */
export function isPastelUri(uri: string | null | undefined): boolean {
  return uri?.startsWith('pastel:') ?? false;
}

/** Parse a pastel URI to get the hex color */
export function parsePastelUri(uri: string): string | null {
  if (!isPastelUri(uri)) return null;
  return uri.replace('pastel:', '');
}

/** Create a pastel URI from a hex color */
export function createPastelUri(hex: string): string {
  return `pastel:${hex}`;
}
